import getVisibleFields from '../elements/getVisibleFields';
import toggleClass from '../../elements/toggleClass';
import * as formWizardConstants from '../elements/constants';

/**
 * Applies validation results to all visible fields in a form,
 * either adding form errors or removing them
 *
 * @param {Element} form
 * @param {Object} results
 */
export default function applyValidation(form, results) {
  if (!form || !results) return;
  getVisibleFields(form).forEach(input => {
    if (results[input.name]) {
      const message = results[input.name][0];
      applyInputValidation(input, message);
    } else {
      removeInputValidation(input);
    }
  });
}

/**
 * Adds error span to parent node of input with message from validation rule
 * or updates innerHTML if already present
 *
 * @param {Element} input
 * @param {String} message
 */
export const applyInputValidation = (input, message) => {
  if (!input || !message) return;
  const errorSpan = input.parentNode.querySelector(
    formWizardConstants.selectors.formFieldError
  );

  if (errorSpan) {
    errorSpan.innerHTML = message;
  } else {
    const el = document.createElement('span');
    el.className = formWizardConstants.classes.formFieldError;
    el.innerHTML = message;
    toggleClass(input, formWizardConstants.classes.formFieldInputError, true);
    toggleClass(input, formWizardConstants.classes.validatedInput, true);
    input.parentNode.appendChild(el);
  }
};

/**
 * Removes error span from parent node of input
 *
 * @param {Element} input
 */
export const removeInputValidation = input => {
  if (!input) return;
  toggleClass(input, formWizardConstants.classes.formFieldInputError, false);
  toggleClass(input, formWizardConstants.classes.validatedInput, true);
  const errorSpan = input.parentNode.querySelector(
    formWizardConstants.selectors.formFieldError
  );
  if (errorSpan) errorSpan.remove();
};
